<!--
 * @Author: Latte
 * @Date: 2021-08-13 09:37:38
 * @LAstEditors: Latte
 * @LastEditTime: 2021-09-07 16:17:43
 * @FilePath: \Siui.Cloud.Medical.Web\src\views\systemManagement\diagnosisManagement\teamMgt\member\index.vue
-->
<template>
  <div class="app-container">
    <my-table
      :tableData="memberList"
      :conf="conf"
      :pageOpt="pageOpt"
      v-loading="loading"
    >
      <!-- 操作 -->
      <template v-slot:operation="slotData">
        <el-button
          type="primary"
          size="small"
          @click.stop="setManager(slotData.data)"
          :disabled="slotData.data.role === 0 ? false : true"
          >设置管理员</el-button
        >
        <el-button
          type="primary"
          size="small"
          @click.stop="allowPermission(slotData.data)"
          :disabled="slotData.data.permission === 1 ? true : false"
          >设置阅片权限</el-button
        >
        <el-button
          type="info"
          size="small"
          @click.stop="deleteMember(slotData.data)"
          >移除成员</el-button
        >
        <el-button
          type="danger"
          size="small"
          @click.stop="cancelPermission(slotData.data)"
          :disabled="slotData.data.permission === 0 ? true : false"
          >移除阅片权限</el-button
        >
      </template>
    </my-table>
  </div>
</template>


<script>
import { handleRes } from "@/utils/handleRes";
import Vue from "vue";
import {
  setManager,
  deleteMember,
  getMemberDetail,
  allowMemberPermission,
  cancelMemberPermission,
} from "@/api/system/diagnosisManagement/diagnosticTeamUser";
import myTable from "@/components/MyTable/index.vue";
import { teamMemberConf } from "@/config/tableConfig/systemMgt/diagnosticMgt/diagnosticTeamMember";

export default {
  components: {
    myTable,
  },
  provide() {
    this.pageOpt = Vue.observable(this.pageOpt);

    return {
      pageOpt: this.pageOpt,
    };
  },
  data() {
    return {
      loading: false, // 加载开关
      conf: teamMemberConf, // 表格栏配置
      memberList: [], // 成员数组
      // 分页配置
      pageOpt: {
        currentPage: 1,
        pageSize: 10,
        totalCount: 0,
      },
    };
  },
  methods: {
    refreshCurrentList() {
      this.getMemberList();
    },

    /**
     * @description: 获取成员列表
     * @param {*}
     * @return {*}
     */
    getMemberList() {
      this.loading = true;
      const teamID = this.$route.params.teamID;

      const params = {
        keyWord: "",
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sortName: "",
        sortOrder: "",
        teamID: teamID,
        where: "",
      };

      getMemberDetail(params).then((res) => {
        this.memberList = res.data.list;
        console.log(" ---------------------------------------------------");
        console.log("getTeamUserDetail , this.memberList", this.memberList);
        console.log(" ---------------------------------------------------");

        this.utils.stopLoading(this);
      });
    },

    /**
     * @description: 设置管理员
     * @param {*} scope
     * @return {*}
     */
    setManager(scope) {
      this.loading = true;
      console.log(scope);

      const data = {
        teamID: scope.teamID,
        userID: scope.userID,
      };

      setManager(data).then((res) => {
        console.log(" --------------------");
        console.log("setManager , res", res);
        console.log(" --------------------");
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.refreshCurrentList();
        this.utils.stopLoading(this);
      });
    },

    /**
     * @description: 移除成员
     * @param {*} scope
     * @return {*}
     */
    deleteMember(scope) {
      console.log(scope);
      this.loading = true;

      const params = {
        teamID: scope.teamID,
        userID: scope.userID,
      };

      deleteMember(params).then((res) => {
        console.log(" ----------------------");
        console.log("deleteMember , res", res);
        console.log(" ------------s----------");
        this.$message({
          message: "操作成功",
          type: "success",
        });
        this.refreshCurrentList();
        this.utils.stopLoading(this);
      });
    },

    /**
     * @description: 设置阅片权限
     * @param {*} scope
     * @return {*}
     */
    allowPermission(scope) {
      this.loading = true;
      console.log(scope);

      const data = {
        teamID: scope.teamID,
        userID: scope.userID,
      };

      allowMemberPermission(data).then((res) => {
        console.log(" --------------------");
        console.log("allowMemberPermission , res", res);
        console.log(" --------------------");
        handleRes(res);
        this.refreshCurrentList();
        this.utils.stopLoading(this);
      });
    },

    /**
     * @description: 移除阅片权限
     * @param {*} scope
     * @return {*}
     */
    cancelPermission(scope) {
      this.loading = true;
      console.log(scope);

      const data = {
        teamID: scope.teamID,
        userID: scope.userID,
      };

      cancelMemberPermission(data).then((res) => {
        console.log(" --------------------");
        console.log("cancelMemberPermission , res", res);
        console.log(" --------------------");
        handleRes(res);
        this.refreshCurrentList();
        this.utils.stopLoading(this);
      });
    },
  },

  created() {
    this.refreshCurrentList();
  },

  watch: {
    "pageOpt.currentPage": {
      deep: true,
      handler(newData, oldData) {
        console.log(" -----------------------------------");
        console.log("handler , this.pageOpt", this.pageOpt);
        console.log("handler , newData", newData);
        console.log("handler , oldData", oldData);
        console.log(" -----------------------------------");
        this.refreshCurrentList();
      },
    },
  },
};
</script>

<style>
</style>